import React, { useState } from 'react';
import { ServiceResponse } from '../../../app/services/shared/interfaces';
import useAuthService from '../../../app/services/hooks/useAuthService';
import { toast } from 'react-toastify';
import useHandleErrorFields from '../../../hooks/useHandleErrorFields';
import InputField from '../../../components/InputField';

type Props = {
    setSendEmail: (showChangePasswordForm: boolean, email: string) => void;
};

const recoveryPasswordForm = ({ setSendEmail }: Props) => {
    const { fieldErrorMessage, onFocusRemove, setErrors } = useHandleErrorFields();
    const [email, setEmail] = useState('');
    const { sendCodeRecoveryPassword } = useAuthService();

    const onClickSendCodeRecoveryPassword = () => {
        sendCodeRecoveryPassword(email, {
            onSuccess: (response: ServiceResponse) => {
                setSendEmail(true, email);
            },
            onError: (response: ServiceResponse) => {
                toast.error(response.message);
            },
            onFieldError: (response: ServiceResponse) => {
                setErrors(response.data);
            }
        });
    };

    return (
        <div className="recovery-form">
            <InputField
                type="email"
                label="Correo electrónico"
                value={email}
                onChange={setEmail}
                onFocus={() => onFocusRemove('email')}
                placeholder="Ingrese su correo electrónico"
                error={fieldErrorMessage('email')}
                icon="fas fa-envelope"
                backgroundColor="#FAFBFC"
                required
            />

            <button
                onClick={onClickSendCodeRecoveryPassword}
                type="button"
                className="btn-recovery"
            >
                <span>Enviar Código</span>
                <i className="fas fa-paper-plane"></i>
            </button>
        </div>
    );
};

export default recoveryPasswordForm;
